import React from "react";
import { Formik, Field, Form } from "formik";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import { jenisKelamin, pendidikan } from "../BenefisUIHelpers";
import { BlockOrg } from "../../../../RoleChecker";

export const BenefisProfileForm = ({ benefis, btnRef, saveBenefis }) => {
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={benefis}
        onSubmit={(values) => {
          saveBenefis({ json_profile: JSON.stringify(values) });
        }}
      >
        {({ handleSubmit, handleChange, setFieldValue, values }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg">
                  <Field
                    type="date"
                    component={Input}
                    name="tanggal_lahir"
                    label="Tanggal Lahir"
                    value={values.tanggal_lahir || ""}
                    onChange={(e) => {
                      setFieldValue("tanggal_lahir", e.target.value);
                    }}
                  />
                </div>
                <div className="col-lg">
                  <Select name="jenis_kelamin" label="Jenis Kelamin">
                    <option value="">--PILIH--</option>
                    {jenisKelamin.map((row) => (
                      <option key={row.value} value={row.value}>
                        {row.name}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg">
                  <Field
                    name="pekerjaan"
                    component={Input}
                    placeholder="Contoh: Pegawai Swasta"
                    label="Pekerjaan"
                  />
                </div>
                <div className="col-lg">
                  <Select name="pendidikan" label="Pendidikan Terakhir">
                    <option value="">-PILIH-</option>
                    {pendidikan.map((row) => (
                      <option key={row.value} value={row.value}>
                        {row.value}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="form-group row">
                <div className="col-lg">
                  <Field
                    name="hobi"
                    component={Input}
                    placeholder="Contoh: Melukis, Memasak...."
                    label="Hobi"
                  />
                </div>
              </div>
              {/* <div className="form-group row">
                <div className="col-lg">
                  <Field
                    name="description"
                    component={Input}
                    placeholder="Donatur ini adalah ..."
                    label="Contoh: Tentang Donatur"
                  />
                </div>
              </div> */}
              {BlockOrg() && (
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                  // style={{ display: "none" }}
                  ref={btnRef}
                  onSubmit={() => handleSubmit()}
                >
                  Simpan
                </button>
              )}
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};
